import axios from "axios";
import { TTP_API_URL, CLIENT_CREDENTIAL } from "Config";

export const getTTPUser = ({ userId, token }) => {
  const filter = [
    {
      property: "id",
      value: userId,
      operator: "eq"
    }
  ];

  const fields = [
    "*",
    "communities",
    "avatar",
    "description",
    "contactSocialNetworks",
    "cover",
    "url",
    "role",
    "roles"
  ];

  const requestUrl = `${TTP_API_URL}/organization/user`;

  let params = {
    access_token: token,
    filter: JSON.stringify(filter),
    fields: fields.join(",")
  };

  return axios.get(requestUrl, {
    //cancelToken: getLatestArticlesSourceToken.token,
    params
  });
};

export const getClientCredential = () => {
  const requestUrl = `${TTP_API_URL}/token`;

  return $.ajax({
    type: "POST",
    async: false,
    url: requestUrl,
    data: CLIENT_CREDENTIAL
  });
};

export const setSelectedOrganization = ({ token, organizationId }) => {
  const requestUrl = `${TTP_API_URL}/organization/user/save-selected-organization`;

  let formData = new FormData();
  formData.append("access_token", token);
  formData.append("organizationId", organizationId);

  return axios.post(requestUrl, formData);
};

export const getSelectedOrganization = token => {
  const requestUrl = `${TTP_API_URL}/organization/user/get-selected-organization`;

  return $.ajax({
    type: "GET",
    async: false,
    url: requestUrl,
    data: `access_token=${token}&fields=${[
      "id",
      "uen",
      "name",
      "url",
      "abbreviation"
    ].join(",")}`
  });
};



// WEBPACK FOOTER //
// ./src/api/auth.js